<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else>
      <div class="no_left_content">
        <h5 class="common_subtitle pb_20 border-lightgray-bottom mb_20">Add disk </h5>
        <div class="vm_checkout_content">
          <div class="vm_checkout_left">
            <div class="mb-3" v-if="customer.selected_service_id == 2">
              <label for="kt_platform" class="col-form-label">Platform</label>
              <select class="form-select" id="kt_platform" v-model="form.kt_platform" @change="changePlatform()">
                <option  v-for="(serverPlatform, index) in serverPlatforms" :key="'kt_platform_'+index" :value="serverPlatform.label">
                  {{ serverPlatform.value }}
                </option>
              </select>
              <v-errors :errors="errorFor('kt_platform')"></v-errors>
            </div>
            <div class="mb-3">
              <label for="server_region_id" class="col-form-label">Region</label>
              <select class="form-select" id="server_region_id" v-model="form.server_region_id" @change="changeRegion()">
                <option  v-for="(serverRegion, index) in serverRegions" :key="'server_region_'+index" :value="serverRegion.id">
                  {{ serverRegion.name }}
                </option>
              </select>
              <v-errors :errors="errorFor('server_region_id')"></v-errors>
            </div>
            <div class="mb-3">
              <label for="name" class="col-form-label">Disk Name</label>
              <input type="text" class="form-control" id="name" v-model="form.name">
              <v-errors :errors="errorFor('name')"></v-errors>
            </div>
            <template v-if="form.kt_platform == 'g'">
              <div class="mb-3">
                <label for="disk_product_type" class="col-form-label">Disk product</label>
                <select class="form-select" v-model="form.disk_product_type" id="disk_product_type" @change="changeDiskProductType()">
                  <option value="HDD">HDD</option>
                  <option value="SSD-Provisioned">SSD-Provisioned</option>
                </select>
                <v-errors :errors="errorFor('disk_product_type')"></v-errors>
              </div>
              <div class="row">
                <div class="col_12" v-if="form.disk_product_type == 'HDD'">
                  <div class="mb-3">
                    <label for="disk_offering_id" class="col-form-label">Volume</label>
                    <select class="form-select" id="disk_offering_id" v-model="form.disk_offering_id" @change="changeDiskVolume()">
                      <option  v-for="(diskOffering, index) in diskOfferings" :key="'disk_offering_'+index" :value="diskOffering.id">
                        {{ diskOffering.size }} GB
                      </option>
                    </select>
                    <v-errors :errors="errorFor('disk_offering_id')"></v-errors>
                  </div>
                </div>
                <template v-else>
                  <div class="col_6">
                    <div class="mb-3">
                      <label for="disk_offering_id" class="col-form-label">Volume</label>
                      <select class="form-select" id="disk_offering_id" v-model="form.disk_offering_id" @change="fetchIops()">
                        <option  v-for="(diskOffering, index) in diskOfferings" :key="'disk_offering_'+index" :value="diskOffering.id">
                          {{ diskOffering.size }} GB
                        </option>
                      </select>
                      <v-errors :errors="errorFor('disk_offering_id')"></v-errors>
                    </div>
                  </div>
                  <div class="col_6" >
                    <div class="mb-3">
                      <label for="disk_offering_iops" class="col-form-label">IOPS</label>
                      <select class="form-select" id="disk_offering_iops" v-model="form.selected_iops_id" @change="changeIops()">
                        <option  v-for="(diskOfferingIop, index) in diskOfferingIops" :key="'disk_offering_iops_'+index" :value="diskOfferingIop.id">
                          {{ diskOfferingIop.iops }}
                        </option>
                      </select>
                      <v-errors :errors="errorFor('disk_offering_id')"></v-errors>
                    </div>
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              <div class="mb-3">
                <label for="disk_product_type" class="col-form-label">Disk product</label>
                <select class="form-select" v-model="form.disk_product_type" id="disk_product_type">
                  <option value="HDD">HDD</option>
                  <option value="SSD">SSD</option>
                </select>
                <v-errors :errors="errorFor('disk_product_type')"></v-errors>
              </div>
              <div class="mb-3">
                <label for="space" class="col-form-label">Capacity</label>
                <input type="number" min="10" step="10" class="form-control" id="space" v-model="form.space" @input="validateSpace">
                <small v-if="errorMessages" class="text-danger">{{errorMessages}}</small>
                <v-errors :errors="errorFor('space')"></v-errors>
              </div>
            </template>
            <div class="mb-3">
              <label for="billing_type" class="col-form-label">Billing type</label>
              <select class="form-select" v-model="form.billing_type" id="billing_type">
                <option value="monthly">Monthly</option>
                <option value="hourly">Hourly</option>
              </select>
              <v-errors :errors="errorFor('billing_type')"></v-errors>
            </div>
          </div>
          <div class="vm_checkout_right">
            <div class="vm_checkout_right_wrap">
              <h5 class="common_subtitle">Estimated Bill</h5>
              <div class="checkout_right_inner">
                <div class="d_flex_btwn inner_title">
                  <span>Disk details</span>
                  <template v-if="form.kt_platform == 'g'">
                    Kt cloud price: {{ formatPrice(getKtCloudPrice) }}
                    <br>
                    Vlan24 price: {{ formatPrice(getVlan24Price) }}
                  </template>
                  <template v-else>
                    Kt cloud price: {{ formatPrice(calculatedKtPrice) }}
                    <br>
                    Vlan24 price: {{ formatPrice(calculatedVlan24Price) }}
                  </template>
                </div>
                <div class="vm_checkout_table">
                  <table class="table">
                    <tbody>
                    <tr>
                      <td>Disk volume</td>
                      <template v-if="form.kt_platform == 'g'">
                        <td>{{ selectedDiskOfferingIops ? selectedDiskOfferingIops?.size : selectedDiskOffering?.size }} GB</td>
                      </template>
                      <template v-else>
                        <td>{{ form.space }} GB</td>
                      </template>
                    </tr>
                    <template v-if="form.kt_platform == 'g'">
                      <tr>
                        <td>IOPS</td>
                        <td>{{ selectedDiskOfferingIops ? selectedDiskOfferingIops?.iops : selectedDiskOffering?.iops }}</td>
                      </tr>
                    </template>
                    </tbody>
                  </table>
                </div>
                <div class="checkout_subtotal">
                  <template v-if="form.billing_type == 'monthly'">
                    <p class="mb_5">Total estimated bill( {{ form.billing_type }} )</p>
                    <template v-if="form.kt_platform == 'g'">
                      <h2 class="subtotal">{{ formatPrice(getVlan24Price) }}</h2>
                    </template>
                    <template v-else>
                      <h2 class="subtotal">{{ formatPrice(calculatedVlan24Price) }}</h2>
                    </template>
                  </template>
                  <template v-else>
                    <p class="mb_5">Total estimated bill( {{ form.billing_type }} )</p>
                    <template v-if="form.kt_platform == 'g'">
                      <h2 class="subtotal">{{ formatPrice(getVlan24Price) }}</h2>
                    </template>
                    <template v-else>
                      <h2 class="subtotal">{{ formatPrice(calculatedVlan24Price) }}</h2>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d_flex_end custom_border_top mt_20 pt_20 pb_20">
        <button type="button" class="btn btn-outline-danger mr_5" @click.prevent="cancelOperation()">Cancel</button>
        <button type="button" class="btn btn-primary btn-md  width_100p" v-if="form.kt_platform == 'g'" :disabled="lyLoading" @click.prevent="submit">Launch</button>
        <button type="button" class="btn btn-primary btn-md  width_100p" v-else :disabled="lyLoading" @click.prevent="submitDplatform">Launch</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
export default {
  name: 'CloudDiskForm',
  components: {LoaderMaskComponent},
  data(){
    return {
      lyLoading: false,
      form: {
        kt_platform: 'g',
        server_region_id: '',
        name: '',
        disk_product_type: 'HDD',
        billing_type: 'hourly',
        disk_offering_id: '',
        selected_iops_id: '',
        space: 10,
      },
      serverRegions: [],
      diskOfferings: [],
      selectedDiskOffering: null,
      diskOfferingIops: [],
      selectedDiskOfferingIops: null,
      errorMessages: '',
    }
  },
  computed:{
    ...mapGetters({
      customer: 'auth/getUserInfo',
    }),
    calculatedPrice() {
      const { disk_product_type, space, billing_type } = this.form;
      if (space % 10 !== 0) {
        return 0;
      }

      let pricePerUnit;

      if (billing_type === "monthly") {
        pricePerUnit = disk_product_type === "HDD" ? 700 : 1400;
      } else if (billing_type === "hourly") {
        pricePerUnit = disk_product_type === "HDD" ? 1 : 2;
      }

      const totalPrice = (space / 10) * pricePerUnit;
      return Math.ceil(totalPrice);
    },
    getVlan24Price(){
      let price = 0
      if(this.form.billing_type == 'monthly'){
        let cPrice =  this.selectedDiskOfferingIops ? this.selectedDiskOfferingIops?.monthly_price : this.selectedDiskOffering?.monthly_price
        price =  cPrice - (cPrice * (this.customer.commission/100))
      }else if(this.form.billing_type == 'hourly'){
        let cPrice = this.selectedDiskOfferingIops ? this.selectedDiskOfferingIops?.hourly_price : this.selectedDiskOffering?.hourly_price
        price =  cPrice - (cPrice * (this.customer.commission/100))
      }
      return Math.ceil(price)
    },
    getKtCloudPrice(){
      let price = 0
      if(this.form.billing_type == 'monthly'){
        price =  this.selectedDiskOfferingIops ? this.selectedDiskOfferingIops?.monthly_price : this.selectedDiskOffering?.monthly_price
      }else if(this.form.billing_type == 'hourly'){
        price =  this.selectedDiskOfferingIops ? this.selectedDiskOfferingIops?.hourly_price : this.selectedDiskOffering?.hourly_price
      }
      return Math.ceil(price)
    },
    calculatedVlan24Price() {
      const { disk_product_type, space, billing_type } = this.form;
      if (space % 10 !== 0) {
        return 0;
      }
      let pricePerUnit;
      if (billing_type === "monthly") {
        pricePerUnit = disk_product_type === "HDD" ? 700 : 1400;
      } else if (billing_type === "hourly") {
        pricePerUnit = disk_product_type === "HDD" ? 1 : 2;
      }
      const totalPrice = (space / 10) * pricePerUnit;
      let price =  totalPrice - (totalPrice * (this.customer.commission/100))
      return Math.ceil(price);
    },
    serverPlatforms(){
      if(this.customer.g_platform && this.customer.d_platform){
        return [
          {label: 'g', value: 'G'},
          {label: 'd', value: 'D'},
        ];
      }else if(this.customer.g_platform){
        return [
          {label: 'g', value: 'G'},
        ];
      }else if(this.customer.d_platform){
        return [
          {label: 'd', value: 'D'},
        ];
      }else{
        return [
          {label: 'g', value: 'G'},
        ];
      }
    }
  },
  created() {
    this.loadServerRegions()
  },
  methods: {
    changePlatform() {
      this.loadServerRegions()
    },
    loadServerRegions() {
      this.axios.get('/server-regions/'+this.form.kt_platform)
          .then(({data}) => {
            this.serverRegions = data.data
            if(this.serverRegions.length > 0){
              this.form.server_region_id = this.serverRegions[0].id
              if(this.form.kt_platform == 'g'){
                this.fetchDiskOfferings()
              }else{
                this.selectedDiskOffering = null
                this.selectedDiskOfferingIops = null
                this.form.disk_offering_id = ''
                this.form.selected_iops_id = ''
                this.diskOfferings = []
                this.diskOfferingIops = []
              }
            }else{
              this.form.server_region_id = ''
            }
          })
    },
    changeRegion(){
      if(this.form.kt_platform == 'g'){
        this.fetchDiskOfferings()
      }
    },
    changeDiskProductType(){
      this.fetchDiskOfferings()
    },
    fetchDiskOfferings(){
      let formData = {
        kt_platform: this.form.kt_platform,
        server_region_id: this.form.server_region_id,
        disk_product_type: this.form.disk_product_type,
      };
      this.axios.post('/get-disk-offerings', formData)
          .then(({data}) => {
            this.diskOfferings = data
            if(this.diskOfferings.length > 0){
              this.selectedDiskOffering =  this.diskOfferings[0]
              this.form.disk_offering_id = this.selectedDiskOffering.id
              if(this.form.disk_product_type == 'SSD-Provisioned'){
                this.fetchIops()
              }else{
                this.diskOfferingIops = []
                this.selectedDiskOfferingIops = null
                this.form.selected_iops_id = ''
              }
            }else{
              this.selectedDiskOffering = null
              this.form.disk_offering_id = ''
              this.diskOfferingIops = []
              this.selectedDiskOfferingIops = null
              this.form.selected_iops_id = ''
            }
          })
    },
    fetchIops(){
      let result = this.diskOfferings.filter(e => e.id == this.form.disk_offering_id)
      this.selectedDiskOffering = result[0]

      let formData = {
        server_region_id: this.form.server_region_id,
        kt_platform: this.form.kt_platform,
        discofferings: this.selectedDiskOffering.discofferings
      };
      this.axios.post('/get-disk-offering-iops', formData)
          .then(({data}) => {
            this.diskOfferingIops = data
            if(this.diskOfferingIops.length > 0){
              this.selectedDiskOfferingIops =  this.diskOfferingIops[0]
              this.form.selected_iops_id = this.selectedDiskOfferingIops.id
            }else{
              this.selectedDiskOfferingIops = null
              this.form.selected_iops_id = ''
            }
          })
    },
    validateSpace() {
      if (this.form.space % 10 !== 0) {
        this.errorMessages = "Capacity must be in increments of 10 GB.";
      } else {
        this.errorMessages = null;
      }
    },
    changeDiskVolume(){
      let result = this.diskOfferings.filter(e => e.id == this.form.disk_offering_id)
      this.selectedDiskOffering = result[0]
    },
    changeIops(){
      let result = this.diskOfferingIops.filter(e => e.id == this.form.selected_iops_id)
      this.selectedDiskOfferingIops = result[0]
    },
    cancelOperation(){
      this.$swal({
        title: 'Are you sure want to cancel?',
        text: "It will stop disk creation!",
        showCancelButton: true,
        confirmButtonText: 'Yes, cancel it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push('cloud-disks');
        }
      });
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      this.axios.post('/cloud-disks', this.form)
          .then((response) => {
            if(response.data.success){
              this.showSuccessMsg(response.data.message);
              this.$router.push('cloud-disks');
            }else{
              this.$swal({
                text: response.data.message,
                showCancelButton: false,
                confirmButtonText: 'Close!',
                confirmButtonColor: '#dd4b39',
                reverseButtons: true
              })
            }
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors
            this.showFailMsg(err.response.data.message);
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
    submitDplatform() {
      this.allErrors = null;
      this.lyLoading = true;

      this.axios.post('/d-platform-cloud-disks', this.form)
          .then((response) => {
            if(response.data.success){
              this.showSuccessMsg(response.data.message);
              this.$router.push('cloud-disks');
            }else{
              this.$swal({
                text: response.data.message,
                showCancelButton: false,
                confirmButtonText: 'Close!',
                confirmButtonColor: '#dd4b39',
                reverseButtons: true
              })
            }
          })
          .catch((err) => {
            this.errorMessages = ''
            this.allErrors = err.response.data.errors
            this.showFailMsg(err.response.data.message);
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
  }
}
</script>
<style scoped>

</style>